/* @flow */

import React from 'react';
import { Card, Divider } from 'semantic-ui-react';
import OctoResourceImage from 'shared/components/OctoResourceImage';
import EditoRenderer from 'edito/Render';

type Props = {
  content: CatalogPageContent,
};

const headerTitle = content =>
  content.title || content.shortTitle || 'Aucun titre';

const View = ({ content }: Props) => {
  return (
    <div>
      <Card centered>
        <Card.Content header={headerTitle(content)} />
        <OctoResourceImage
          strategy={content._imageResourceStrategy}
          resource={content.image}
        />
      </Card>
      <Divider />
      <EditoRenderer
        fetchTemplatesUrl="/catalog/flow/templates.json"
        blocks={content.blocks || []}
      />
    </div>
  );
};

export default View;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/flow/simple/View.js